import "./App.css";
import Overlay from "./layout/Overlay";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { useEffect } from "react";
import { useAppSelector } from "./store/Hooks";
import { useTranslation } from "react-i18next";
import { HtmlHelper } from "./utils/HtmlHelper";
import { QueryClient, QueryClientProvider } from "react-query";
import React from "react";
import { PDFRenderer } from "./components/common/PDFRenderer";
import { ConfigProvider, theme } from "antd";
import Chat from "./components/chat";
const { defaultAlgorithm, darkAlgorithm } = theme;

function App() {
  const store = useAppSelector((state) => state.site);
  const { i18n } = useTranslation();
  const queryClient = new QueryClient()

  useEffect(() => {
    var darkMode = store.darkMode;
    if (darkMode != null) {
      var mode = String(darkMode) === 'true';
      if (mode == true) HtmlHelper.addBodyClass("dark-mode");
      else HtmlHelper.removeBodyClass("dark-mode");
    }
    store.openMobileMenu
      ? HtmlHelper.addBodyClass("nav-shown")
      : HtmlHelper.removeBodyClass("nav-shown");
    if (store.language != i18n.language) i18n.changeLanguage(store.language);
  }, [store.darkMode, store.openMobileMenu, store.language]);
  return (
    <React.StrictMode>
      <ConfigProvider theme={{ algorithm: store.darkMode ? darkAlgorithm : defaultAlgorithm }}>
        <QueryClientProvider client={queryClient}>
          <Overlay />
          <Chat />
          <PDFRenderer />
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </QueryClientProvider>
      </ConfigProvider>
    </React.StrictMode>
  );
}

export default App;
